// Tijden van de aanloop ("Opladen"), gedeeld door beeld (AnimationLayer.js)
// en geluid (audio/cues.js): elk blokje dat aanspringt is een tik. De blokjes
// komen eerst traag en daarna steeds sneller.

export const chargeCells = 16;

// Eerst donker en de kop, dan het eerste blokje.
export const chargeStartMs = 300;

// Het gat tussen twee blokjes, van het eerste naar het laatste.
export const chargeFirstGapMs = 170;
export const chargeLastGapMs = 55;

// Wanneer blokje `index` aanspringt.
export function chargeCellMs(index) {
  const gaps = chargeCells - 1;
  let at = chargeStartMs;
  for (let i = 0; i < index; i += 1) {
    at += chargeFirstGapMs - (chargeFirstGapMs - chargeLastGapMs) * (i / gaps);
  }
  return Math.round(at);
}

// De rij is vol: de flits, daarna de aankondiging (chargeHandoff in useSaleEvents.js).
export const chargeFullMs = chargeCellMs(chargeCells - 1);

// Blijft staan tot het donker van de aankondiging het overneemt, anders licht het scherm op.
export const chargeMs = 2600;
